<script setup>
import { computed, onMounted } from 'vue';
import AppMenuItem from './AppMenuItem.vue';

import { useAuthStore } from '@/stores/auth';
import { usePriceEntryStore } from '@/stores/priceEntry';

const authStore = useAuthStore();
const priceEntryStore = usePriceEntryStore();

const hasPermission = (permission) => {
    if (Array.isArray(permission)) {
        return permission.some((perm) => authStore.allowedLinks.includes(perm));
    } else {
        return !permission || authStore.allowedLinks.includes(permission);
    }
};

const model = computed(() => {
    const items = [
        {
            label: 'Dashboards',
            icon: 'pi pi-home',
            permission: ['is_musteri', 'is_bayi'],
            items: [
                {
                    label: 'Genel Dashboard',
                    icon: 'pi pi-fw pi-home',
                    to: '/'
                },

            ]
        },
        {
            label: 'Dashboards',
            icon: 'pi pi-home',
            permission: ['is_yonetici', 'is_superuser'],
            items: [
                {
                    label: 'Genel Dashboard',
                    icon: 'pi pi-fw pi-home',
                    to: '/'
                },
                {
                    label: 'Kullanıcı Aktiviteleri',
                    icon: 'pi pi-fw pi-user',
                    to: '/dashboard/active-users/'
                },
                {
                    label: 'Satışlar',
                    icon: 'pi pi-fw pi-wallet',
                    to: '/dashboard/orders/'
                }
            ]
        },
        {
            label: 'Menüler',
            icon: 'pi pi-users',
            permission: ['is_yonetici', 'is_superuser'],
            items: [
                {
                    label: 'Satışlar',
                    icon: 'pi pi-fw pi-wallet',
                    items: [
                        {
                            label: 'Satış Tablosu',
                            icon: 'pi pi-fw pi-ellipsis-h',
                            to: '/orders'
                        },
                        {
                            label: 'Müşteri Listesi',
                            icon: 'pi pi-fw pi-ellipsis-h',
                            to: '/orders/customers'
                        }
                    ]
                },
                {
                    label: 'Kullanıcı Listesi',
                    icon: 'pi pi-fw pi-users',
                    to: '/user-management'
                },
                {
                    label: 'Kategoriler',
                    icon: 'pi pi-fw pi-sitemap',
                    to: '/category'
                },
                {
                    label: 'Markalar',
                    icon: 'pi pi-fw pi-star',
                    to: '/brand'
                },
                {
                    label: 'Pazaryeri',
                    icon: 'pi pi-fw pi-shop',
                    to: '/market-place'
                },
                {
                    label: 'Özellikler',
                    icon: 'pi pi-list-check',
                    to: '/features'
                },
                {
                    label: 'Ürünler',
                    icon: 'pi pi-barcode',
                    items: [
                        {
                            label: 'Ürünler',
                            icon: 'pi pi-fw pi-ellipsis-h',
                            to: '/product'
                        },
                        {
                            label: 'Fiyat Girilecek',
                            icon: 'pi pi-fw pi-ellipsis-h',
                            to: '/product/price-entry',
                            badge: priceEntryStore.count
                        }
                    ]
                },
                {
                    label: 'Satınalma',
                    icon: 'pi pi-truck',
                    to: '/satinalma'
                },
                {
                    label: 'Bildirim Yönetimi',
                    icon: 'pi pi-bell',
                    to: '/notification'
                }
            ]
        },
        // Müşteriler için özel menü
        {
            label: 'Menüler',
            icon: 'pi pi-users',
            permission: ['is_musteri', 'is_bayi'],
            items: [
                {
                    label: 'Ürünler',
                    icon: 'pi pi-barcode',
                    to: '/product'
                }
            ]
        },
    ];

    return items.filter((model) => hasPermission(model.permission));
});

// Rozet sayısı yalnızca fiyat girebilen roller için okunur
onMounted(() => {
    if (hasPermission(['is_yonetici', 'is_superuser'])) {
        priceEntryStore.fetchCount();
    }
});
</script>

<template>
    <ul class="layout-menu">
        <template v-for="(item, i) in model" :key="item">
            <AppMenuItem :item="item" root :index="i" />
            <li class="menu-separator"></li>
        </template>
    </ul>
</template>
